module.exports = __webpack_public_path__ + "media/images/pinterest-d8747522c24f7abce0de46b08dd55a1a.png";